import { LightBox } from "./components/LightBox";

export default LightBox;
